/*
 * action 类型
 */

export const type = {
    INFOTYPE : 'INFOTYPE',
    artType:'artTYPE',
    loginType:'LOGINTYPE',
    ArtIdType:'ArtIdType',
    showMsgType:'SHOWMSG',
    isLoginType:'ISLOGINTYPE'
    
};



export function changeHeadType(headName) {
    return {
        type:type.INFOTYPE,
        headName
    }
}

export function changeArtName(artName) {
    return {
        type:type.artType,
        artName
    }
}

export function changeArtId(artId) {
    return {
        type:type.ArtIdType,
        artId
    }
}


export function changeLoginShow(isShow,isReg) {
    return {
        type:type.loginType,
        isShow,
        isReg
    }
}

export function changeShowMsg(showMsg) {
    return {
        type:type.showMsgType,
        showMsg
    }
}

export function changeIsLogin(isLogin) {
    return {
        type:type.isLoginType,
        isLogin
    }
}